import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.png";
import Work5 from "../../assets/work5.png";
import Work6 from "../../assets/work6.png";


export const projectsData = [
    {
      id: 1,
      image: Work1,
      title: "Blog",
      category: "web",
      link: "http://web.archive.org/web/20220325051321/https://anotherwhy.com/",
    },
    {
      id: 2,
      image: Work2,
      title: "Bus Reservation System",
      category: "app",
      link: "https://github.com/indranilbhuin/Bus_Reservation_System_Project_CipherSchools",
    },
    {
      id: 3,
      image: Work3,
      title: "Brand design",
      category: "design",
      link: "https://drive.google.com/drive/folders/1D5wvQdS1A8b5BdgLgwnDZM0vNj-YMjTy?usp=share_link",
    },
    {
      id: 4,
      image: Work4,
      title: "Animal World",
      category: "web",
      link: "https://indranilbhuin.github.io/animal-world/",
    },
    {
      id: 5,
      image: Work5,
      title: "Dice Game",
      category: "web",
      link: "https://indranilbhuin.github.io/dice-game/",
    },
    {
      id: 6,
      image: Work6,
      title: "You are in Safe Hands",
      category: "publication",
      link: "https://www.amazon.in/dp/B09XF4KJN8",
    },
  ];

  export const projectsNav = [
    {
        name: "all",
    },
    {
        name: "web",
    },
    {
        name: "app",
    },
    {
        name: "design",
    },
    {
        name: "publication",
    },
  ];